<iframe [ngStyle]="{ height: iframeHeight + 'px' }" #iframe></iframe>
